const sidenav = {
  abandonedCallsBadge: 'MainLayout-Sidenav-AbandonedCallsBadge',
  secondChanceLeadsBadge: 'MainLayout-Sidenav-SecondChanceLeadsBadge',
  inboxPageNavButton: 'MainLayout-Sidenav-InboxPageNavButton',
  userManagementPageNavBtn: 'MainLayout-Sidenav-UserManagementPageNavButton',
  workflowManagementPageNavBtn:
    'MainLayout-Sidenav-WorkflowManagementPageNavButton',
} as const;

const outboundModal = {
  employeeRowRadioBtn: 'Layout-NavBar-OutboundModal-EmployeeRowRadioBtn',
  placeCallBtn: 'Layout-NavBar-OutboundModal-PlaceCallBtn',
  keypadBtn: 'Layout-NavBar-OutboundModal-KeypadBtn',
} as const;

const navBar = {
  disconnectButton: 'MainLayout-NavBar-DisconnectButton',
  logo: 'MainLayout-NavBar-Logo',
  userStatusMenu: 'MainLayout-NavBar-UserStatusMenu',
  userStatusMenuOption: 'MainLayout-NavBar-UserStatusMenuOption',
  outboundModal,
  settingsBtn: 'Layout-NavBar-SettingsBtn',
  callBtnIcon: 'Inbox-CallBar-CallButtonIcon',
} as const;

const toastGroup = {
  toast: 'Layout-ToastGroup-Toast',
};

export const mainLayoutLocators = {
  sidenav,
  navBar,
  toastGroup,
} as const;
